import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * CreateConversation
 *
 * @private
 */
export const createConversation = createAsyncThunk<
  // Return type of the payload creator
  uui.domain.actions.rpc.routingAssistant.CreateConversationResult['result'],
  // First argument to the payload creator
  uui.domain.actions.rpc.routingAssistant.CreateConversationAction['payload'],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('rpc/routing-assistant/createConversation', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/routing-assistant/createConversation', {
      category: 'rpc',
      type: 'rpc/routing-assistant/createConversation',
      payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on createConversation`,
      { tags: ['rpc', 'routing-assistant'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `createConversation call failed`,
      error,
    })
  }
})
